import React, {Component} from "react";
import PropTypes from "prop-types";
import LoadingStates from "../App.js";
import { Link } from "react-router-dom";

class Ads extends Component {
	constructor(props) {
		super(props);

		this.selectItem = props.selectable ? this.selectItem.bind(this) : null;
		this.selectAll = props.selectable ? this.selectAll.bind(this) : null;

		const defaultSelected = props.defaultSelectedItems ? props.defaultSelectedItems : [];
		const defaultTotal = defaultSelected.reduce((total, ad) => total + ad.storedCost - ad.amtPrepaid, 0.00);

		this.state = {
			selectedItems: defaultSelected,
			totalSelected: defaultTotal
		};
	}

	selectItem(item, selected) {
		var newItems;
		if (selected) {
			newItems = Array.from(this.state.selectedItems);
			newItems.push(item);
		} else {
			newItems = this.state.selectedItems.filter(ad => ad["id"] !== item["id"]);
		}
		this.setSelectedItems(newItems);
	}

	selectAll(event) {
		let selected = event.target.checked;
		let newItems = selected ? Array.from(this.props.ads) : [];
		this.setSelectedItems(newItems);
	}

	setSelectedItems(selectedItems) {
		let total = selectedItems ? 
			selectedItems.reduce((total, ad) => total = total + ad.storedCost - ad.amtPrepaid, 0.00) : 0.00;
		this.setState({
			selectedItems: selectedItems,
			totalSelected: total
		});
		if (this.props.onSelectedItemsChanged) {
			this.props.onSelectedItemsChanged([...selectedItems]);
		}
	}

	render() {
		let loadingState = this.props.loadingState;
		let ads = this.props.ads;
		let selectable = this.props.selectable;

		switch (loadingState) {
		case LoadingStates.inProgress:
			return (
				<div className="CustomerAccountInfo-Ads">
					<h2>Loading Currently Running Ads</h2>
				</div>
			);

		case LoadingStates.failed:
			return (
				<div className="CustomerAccountInfo-Ads">
					<h2 className="loadingError">There was an error loading your currently running ads</h2>
				</div>
			);
		default:
			break;
		}

		if (ads == null || ads.length === 0) {
			return null;
		}

		let headerText = this.props.description;
		let totalLabel = "Total of "+headerText;
		
		let totalString = ads
			.reduce((total, ad) => total + ad.storedCost - ad.amtPrepaid, 0).formatMoney();

		let totalSelected = this.state.totalSelected;
		let totalSelectedStr = totalSelected && (totalSelected > 0.00) ? totalSelected.formatMoney() : "";
	
		let allChecked = ads.length === this.state.selectedItems.length;
		let checkHeader = selectable ? 
			<th className="money checkColumn">Pay 
				<input type="checkbox" checked={allChecked} onChange={this.selectAll}/></th> : null;
		let checkTotal = selectable ? 
			<th className="money checkColumn">{totalSelectedStr}</th> : null;
		let totalSpan = 6; //selectable ? 7 : 6;
	
		return (
			<div className="CustomerAccountInfo-Ads">
				<h2>{headerText}</h2>
				<table>
					<thead>
						<tr>
							<th>Ad</th>
							<th>Run Date</th>
							<th colSpan="2">Status</th>
							<th>Description</th>
							<th className="money">Charge</th>
							<th className="money">Amt. Due</th>
							{checkHeader}
						</tr>
					</thead>
					<tbody>
						{ads.map(ad => {
							let adKey =  makeAdKey(ad);
							let selected = this.state.selectedItems ? 
								this.state.selectedItems.findIndex(selAd => 
									makeAdKey(selAd) === adKey) >= 0 : 
								false;
							return (
								<Ad 
									ad={ad} 
									key={adKey} 
									selected={selected}
									selectAction={this.selectItem}
								/>
							);
						})}
					</tbody>
					<tfoot>
						<tr>
							<th colSpan={totalSpan} className="money">{totalLabel}</th>
							<th className="money">{totalString}</th>
							{checkTotal}
						</tr>
					</tfoot>
				</table>

			</div>
		);
	}
}

Ads.propTypes = {
	loadingState: PropTypes.number,
	ads: PropTypes.array,
	description: PropTypes.string,
	selectable: PropTypes.bool,
	onSelectedItemsChanged: PropTypes.func,
	defaultSelectedItems: PropTypes.array
};

function makeAdKey(ad) {
	return ad.id + ":" + ad.firstDate;
}

function Ad(props) {
	let ad = props.ad;
	let adId = ad.id;
	let runDate = ad.firstDate.toLocaleDateString();
	let status = creditStatusTypes.descriptionOf(ad.creditStatus);
	let description = ad.adType+", " + ad.adSizeDesc; // + ": " + ad.copyRef;
	let amount = ad.storedCost.formatMoney();
	let receivable = (ad.storedCost - ad.amtPrepaid).formatMoney();
	let selectable = props.selectAction !== null;
	let checkbox = selectable ? 
		<td className="money">
			<input 
				type="checkbox" 
				checked={props.selected}
				onChange={(event) => 
					props.selectAction(props.ad, event.target.checked)
				}/>
		</td> : null;

	var statusIcon, statusClass;
	if (creditStatusTypes.isRunning(ad.creditStatus)) {
		statusIcon = "";
		statusClass = "highlightGood";
	} else if (creditStatusTypes.isCanceled(ad.creditStatus)) {
		statusIcon = "⚠️";
		statusClass = "highlightWarn";
	} else {
		statusIcon = "🛑";
		statusClass = "highlightProblem";
	}
	
	var creditStatusLine2 = creditStatusTypes.secondaryDescriptionOf(ad.creditStatus);

	return (
		<React.Fragment>
			<tr>
				<td>{adId}</td>
				<td>{runDate}</td>
				<td>{statusIcon}</td>
				<td className={statusClass}>{status}</td>
				<td>{description}</td>
				<td className="money">{amount}</td>
				<td className="money">{receivable}</td>
				{checkbox}
			</tr>
			<tr>
				<td colSpan="3"></td>
				<td className={statusClass}>{creditStatusLine2}</td>
				<td>{ad.copyRef}</td>
				<td colSpan="2"></td>
			</tr>
		</React.Fragment>
	);
}

Ad.propTypes = {
	ad: PropTypes.object,
	selected: PropTypes.bool,
	selectAction: PropTypes.func
};

let creditStatusTypes = {
	"statuses" : [
		{"id" : 0, "description": "Approved"},
		{"id" : 1, "description": "Approved: Credit"},
		{"id" : 10, "description": "Make Good"},
		{"id" : 40, "description": "Canceled"},
		{"id" : 41, "description": "Canceled: Refund"},
		{"id" : 42, "description": "Canceled: No Refund"},
		{"id" : 50, "description": "On Hold"}, //Discretionary
		{"id" : 100, "description": "On Hold"}, //Payment Required
		{"id" : 105, "description": "On Hold"}, //Past Credit Limit
		{"id" : 110, "description": "On Hold"} //30 Days Past Due
	],

	descriptionOf(id) {
		let obj = this.statuses.find(status => status.id === id);
		if (obj) {
			return obj.description;
		} else {
			return "Unknown Credit Status " + id;
		}
	},
	
	secondaryDescriptionOf(id) {
		return this.isHoldStatus(id) ? 
			(this.isCallUs(id) ? <Link to="/contact">Contact us</Link> : "Payment Required") : " ";
	},

	isHoldStatus(id) {
		return id >= 50;
	},
	
	isCallUs(id) {
		return this.isHoldStatus(id) && id !== 100;
	},

	isCanceled(id) {
		return id >= 40 && id < 50;
	},

	isRunning(id) {
		return id < 40;
	}
};

export default Ads;


// WEBPACK FOOTER //
// ./src/components/Ads.js